import { Data_getInstance1kmwiv1j3ytfz as Data_getInstance } from './adapter/BeginDiscordOAuthMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { BeginDiscordOAuthMutationSelections_getInstance1ouhs7sr8oxf4 as BeginDiscordOAuthMutationSelections_getInstance } from './selections/BeginDiscordOAuthMutationSelections.mjs';
import { BeginDiscordOAuthMutation_VariablesAdapter_instance3gwtd23afv9v6 as BeginDiscordOAuthMutation_VariablesAdapter_instance } from './adapter/BeginDiscordOAuthMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(beginDiscordOAuth) {
        this.f6g_1 = beginDiscordOAuth;
      }
      toString() {
        return 'Data(beginDiscordOAuth=' + toString(this.f6g_1) + ')';
      }
      hashCode() {
        return this.f6g_1 == null ? 0 : this.f6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.f6g_1, other.f6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var BeginDiscordOAuthClass;
function BeginDiscordOAuth() {
  if (BeginDiscordOAuthClass === VOID) {
    class $ {
      constructor(state, expiresAt) {
        this.g6g_1 = state;
        this.h6g_1 = expiresAt;
      }
      toString() {
        return 'BeginDiscordOAuth(state=' + this.g6g_1 + ', expiresAt=' + this.h6g_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.g6g_1);
        result = imul(result, 31) + getStringHashCode(this.h6g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BeginDiscordOAuth()))
          return false;
        if (!(this.g6g_1 === other.g6g_1))
          return false;
        if (!(this.h6g_1 === other.h6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BeginDiscordOAuth');
    BeginDiscordOAuthClass = $;
  }
  return BeginDiscordOAuthClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i6g_1 = obj(Data_getInstance());
        this.j6g_1 = (new (Builder())('data', Companion_getInstance().g6h_1)).p46(BeginDiscordOAuthMutationSelections_getInstance().i6h_1).e3a();
        this.k6g_1 = '0812fe77826f4f252d45419af4c040e5ca61e7edc67daa9f38775de439d68412';
        this.l6g_1 = 'beginDiscordOAuth';
      }
      j6h() {
        return 'mutation beginDiscordOAuth($input: BeginDiscordOAuthInput!) { beginDiscordOAuth(input: $input) { state expiresAt } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var BeginDiscordOAuthMutationClass;
function BeginDiscordOAuthMutation() {
  if (BeginDiscordOAuthMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.k6h_1 = input;
      }
      l6h() {
        return '0812fe77826f4f252d45419af4c040e5ca61e7edc67daa9f38775de439d68412';
      }
      operationId() {
        return this.l6h();
      }
      i4a() {
        return Companion_getInstance_0().j6h();
      }
      m6h() {
        return 'beginDiscordOAuth';
      }
      operationName() {
        return this.m6h();
      }
      m49(writer, customScalarAdapters, withDefaultValues) {
        BeginDiscordOAuthMutation_VariablesAdapter_instance.n6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      l49() {
        return Companion_getInstance_0().i6g_1;
      }
      toString() {
        return 'BeginDiscordOAuthMutation(input=' + this.k6h_1.toString() + ')';
      }
      hashCode() {
        return this.k6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BeginDiscordOAuthMutation()))
          return false;
        if (!this.k6h_1.equals(other.k6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BeginDiscordOAuthMutation', VOID, VOID, [Mutation()]);
    BeginDiscordOAuthMutationClass = $;
  }
  return BeginDiscordOAuthMutationClass;
}
//region block: exports
export {
  BeginDiscordOAuth as BeginDiscordOAuth3el1thryt54ev,
  Data as Datarsj944sbse7g,
  BeginDiscordOAuthMutation as BeginDiscordOAuthMutation2pm676kjmhe6s,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthMutation.mjs.map
